import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class PointEditDataCommand extends EditDataCommand {
  protected opType = cadOpType.EDITPTO;
}